import { authenticatedFetch } from "@/api/session";
const API_BASE_URL = "http://localhost:8000";

function getAuthHeaders() {
  const token = localStorage.getItem("access_token");

  return {
    Authorization: `Bearer ${token}`,
  };
}

export type HouseholdIntelligenceMember = {
  id: string;
  first_name: string;
  last_name: string;
  relationship_to_household: string | null;
  is_head_of_household: boolean;
  last_attended_at: string | null;
};

export type HouseholdIntelligenceResponse = {
  assessment_status: "ASSESSED";
  calculated_at: string | null;
  run_id: string | null;
  household_id: string;
  household_name: string;
  health_score: number;
  risk_level: string;
  member_count: number | null;
  attendance_rate: number | null;
  open_care_items: number | null;
  summary: string;
  recommended_action: string;
  insights: HouseholdInsight[];
  contributions: HouseholdScoreContribution[];
  members: HouseholdIntelligenceMember[];
};

export type UnassessedHouseholdIntelligence = Omit<HouseholdIntelligenceResponse, "assessment_status" | "health_score" | "attendance_rate" | "open_care_items"> & {
  assessment_status: "NOT_ASSESSED";
  health_score: null;
  attendance_rate: null;
  open_care_items: null;
};

export async function getHouseholdIntelligence(
  churchId: string,
  householdId: string
): Promise<HouseholdIntelligenceResponse | UnassessedHouseholdIntelligence> {
  const response = await authenticatedFetch(
    `${API_BASE_URL}/api/churches/${churchId}/households/${householdId}/intelligence`,
    {
      headers: getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load household intelligence");
  }

  return response.json();
}

export type HouseholdScoreContribution = {
  source: string;
  health_score: number;
  weight: number;
  weighted_score: number;
  explanation: string;
};

export type HouseholdInsight = {
  severity: string;
  title: string;
  description: string;
  recommendation: string;
};